<template>
  <div class="" v-if="broker != null">
    <div class="text-base text-center">
      <img src="https://img.icons8.com/plasticine/64/000000/confetti.png" class="inline" /><br/>
      Hooray! You're good to go!
    </div>

    <div class="mt-3 text-sm text-gray-700">
      Congratulations, you have completed your <span class="text-blue-500">Adding your First Client Tutorial</span>.
      You can now see this client appear on your 

      <router-link 
        :to="{
          name  : 'client-list',
        }"
        tag="a" 
        class="text-blue-500 underline">client list page</router-link>.
    </div>

    <div class="my-6 text-sm text-gray-700">
      Please note that we only touched a very small part of {{ getAppName }}'s application process.
      Please explore the application and add other details such as
      <span class="text-green-600 font-semibold">Assets</span>,
      <span class="text-green-600 font-semibold">Liabilities</span>,
      <span class="text-green-600 font-semibold">Risk Profile</span>,
      <span class="text-green-600 font-semibold">Documents</span> and much more.
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import InputEmail     from '@/shared/components/form/InputEmail'
  import InputPhone     from '@/shared/components/form/InputPhone'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      InputEmail,
      InputPhone,
      SubmitButton2,
    },

    data () {
      return {
        loading    : false,
        broker     : null,
        application: {
          email      : null,
          mobilePhone: null
        }
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })

      if(this.$route.params.data != null) {
        this.application = JSON.parse(decodeURIComponent(this.$route.params.data))
      }

      if(this.application.email == null) {
        this.application.email = null
      }

      if(this.application.mobilePhone == null) {
        this.application.mobilePhone = null
      }
    },

    methods : {
      updateValue(params) {
        this.application[params.key] = params.value
      },

      next() {
        this.apiPost({
          application : this.application
        }, 'client/create-via-onboarding', (data) => {
          this.application.clientId    = data.client.id
          this.application.applicantId = data.applicant.id

          this.$router.push({
            name  : 'broker-onboard-first-client-done',
            params: {
              brokerId: this.broker.id,
              data    : encodeURIComponent(JSON.stringify(this.application))
            }
          })
        })
      }
    },
  }
</script>